$(function(){
  // ファーストビューで見えているチャートはスクロールしなくても発火
  renderkuchikomiBarChart(this);

  // ファーストビューで隠れているチャートはスクロールで発火
  $(window).scroll(function () {
    renderkuchikomiBarChart(this);
  });

  function renderkuchikomiBarChart(target) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    $('.js-kuchikomi__bar-graph:not(.rendered)').each(function(){
      var elemTop = $(this).offset().top;
      var targetCanvas = $(this);
      if(elemTop < docViewBottom) {
        var kuchikomiBarChart = targetCanvas[0];
        if (kuchikomiBarChart) {
          $(kuchikomiBarChart).addClass('rendered');
          var ctxKuchikomiBar = kuchikomiBarChart.getContext("2d");
          var kuchikomiBarChart = new Chart(ctxKuchikomiBar, {
            plugins: [{
              afterDatasetsDraw: function (chart, easing) {
                var ctx = chart.ctx;

                chart.data.datasets.forEach(function (dataset, i) {
                  var meta = chart.getDatasetMeta(i);
                  if (!meta.hidden) {
                    meta.data.forEach(function (element, index) {
                      ctx.fillStyle = '#333';

                      var fontSize = 14;
                      var fontStyle = 'normal';
                      ctx.font = Chart.helpers.fontString(fontSize, fontStyle);

                      var dataString = dataset.data[index].toString();

                      ctx.textAlign = 'center';
                      ctx.textBaseline = 'middle';

                      var position = element.tooltipPosition();
                      ctx.fillText(dataString, position.x - 20, position.y);
                    });
                  }
                });
              }
            }],
            type: 'horizontalBar',
            data: {
              labels: ['料金と作品数', '操作性'],
              datasets: [{
                data: JSON.parse(kuchikomiBarChart.getAttribute('data-scores')),
                backgroundColor: "rgba(246, 186, 116, 1)",
                hoverBackgroundColor: "rgba(246, 186, 116, 1)"
              }]
            },
            options:{
              responsive: false,
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  barThickness: 20,
                  ticks: {
                    fontSize: 16,
                    fontStyle: 'bold',
                    fontColor: '#333'
                  },
                  gridLines: {
                    display: false
                  }
                }],
                xAxes: [{
                  ticks: {
                    min: 0,
                    max: 5,
                    display: false
                  },
                  gridLines: {
                    color: '#ddd',
                    drawTicks: false,
                    drawBorder: false
                  },
                }]
              },
              tooltips: {
                enabled: false
              },
              animation: false
            }
          });
        }
      }
    });
  }

});
